import styled from 'styled-components';

export const ErrorBoundaryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
  padding: 2rem;
  background: transparent;
`;

export const ErrorContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 3rem;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ErrorIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #fee;
  border-radius: 50%;
  margin-bottom: 1.5rem;
  color: #ef4444;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4);
    }
    70% {
      box-shadow: 0 0 0 20px rgba(239, 68, 68, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
    }
  }
`;

export const ErrorTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
`;

export const ErrorMessage = styled.p`
  font-size: 1rem;
  color: #6b7280;
  line-height: 1.5;
  margin-bottom: 2rem;
`;

export const ErrorDetails = styled.div`
  margin: 2rem 0;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
  text-align: left;
  max-height: 400px;
  overflow-y: auto;
`;

export const ErrorCode = styled.div`
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  color: #dc2626;
  padding: 0.5rem;
  background: #fef2f2;
  border-radius: 4px;
  margin-bottom: 1rem;
  word-break: break-word;

  strong {
    color: #991b1b;
  }
`;

export const ErrorStack = styled.div`
  margin-top: 1rem;
  font-size: 0.75rem;
  color: #374151;

  strong {
    display: block;
    margin-bottom: 0.5rem;
    color: #1f2937;
  }

  pre {
    background: white;
    padding: 1rem;
    border-radius: 4px;
    overflow-x: auto;
    font-family: 'Courier New', monospace;
    font-size: 0.75rem;
    line-height: 1.5;
    white-space: pre-wrap;
    word-wrap: break-word;
    border: 1px solid #e5e7eb;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

interface ActionButtonProps {
  $variant?: 'primary' | 'secondary';
}

export const ActionButton = styled.button<ActionButtonProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  ${({ $variant }) => ($variant === 'primary' ? `
    background: #4f46e5;
    color: white;

    &:hover {
      background: #4338ca;
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(79, 70, 229, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  ` : `
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;

    &:hover {
      background: #e5e7eb;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &:active {
      transform: translateY(0);
    }
  `)}
`;
